import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../components/UI/Spinner/Spinner';

export default (ProtectedComponent, spinnerType = 'Default') => {
  class AuthHOC extends Component {
    isLoggedIn = () => {
      return this.props.auth.authenticated;
    };

    isLoading = () => {
      return this.props.auth.loading;
    };

    retrieveRole = () => {
      return this.props.auth.role;
    };

    render() {
      if (this.isLoading()) {
        return <Spinner type={spinnerType} />;
      } else
        return (
          <ProtectedComponent
            {...this.props}
            isLoading={this.isLoading}
            isLoggedIn={this.isLoggedIn}
            retrieveRole={this.retrieveRole}
          />
        );
    }
  }

  const mapStateToProps = state => ({ ...state });

  return connect(mapStateToProps)(AuthHOC);
};



// WEBPACK FOOTER //
// ./src/HOC/Auth/WithAuth.js